import { useMemo } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import type { Stripe } from '@stripe/stripe-js';

// Module-level cache: one Promise per publishable key across all components and re-renders.
const stripeCache: Record<string, Promise<Stripe | null>> = {};

const useStripePromise = (clientKey: string | null): Promise<Stripe | null> | null =>
  useMemo(() => {
    if (!clientKey) return null;
    if (!stripeCache[clientKey]) {
      stripeCache[clientKey] = loadStripe(clientKey);
    }
    return stripeCache[clientKey];
  }, [clientKey]);

export { useStripePromise };
